import { render, staticRenderFns } from "./PickingForm.vue?vue&type=template&id=16d51ba0"
import script from "./PickingForm.vue?vue&type=script&lang=js"
export * from "./PickingForm.vue?vue&type=script&lang=js"
import style0 from "./PickingForm.vue?vue&type=style&index=0&id=16d51ba0&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports